import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_API_URL).replace(/\/$/, "");

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = typeof window !== "undefined" ? window.localStorage.getItem("token") : null;

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const offsetMinutes = -new Date().getTimezoneOffset();

    config.headers["X-TimeZone"] = timeZone;
    config.headers["X-TimeZone-Offset"] = offsetMinutes;

    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
      delete config.headers["content-type"];
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    
    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && typeof window !== "undefined") {
      window.localStorage.removeItem("token");
      const path = window.location.pathname || "";
      const loginPath = path.startsWith("/admin") ? "/admin/login" : "/login";

      if (path !== loginPath) {
        window.location.replace(loginPath);
      }
    }

    return Promise.reject(error);
  },
);

export default apiClient;
